/* eslint-disable sort-imports */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';

function isDropDown(typeId) {
    var DROPDOWN = 2,
        DROPDOWNALT = 3;

    return typeId === DROPDOWN || typeId === DROPDOWNALT;
}

function isRadioButton(typeId) {
    var RADIO_BUTTON_ID = 5;
    return typeId === RADIO_BUTTON_ID;
}

function isCheckBox(typeId) {
    var CHECKBOX_ID = 1;
    return typeId === CHECKBOX_ID;
}

function Question(data, accountId, save) {
    ko.mapping.fromJS(data, {}, this);

    this.accountId = accountId;
    this.questionData = data;
    this.answerData = data.Answers;
    this.isDropDown = isDropDown(data.DisplayTypeId);
    this.isRadioButton = isRadioButton(data.DisplayTypeId);
    this.isCheckBox = isCheckBox(data.DisplayTypeId);
    this.showAnswer = ko.observable(false);
    this.showChoices = ko.observable(true);
    this.selectedAnswerId = ko.observable();
    this.selectedAnswerIds = ko.observableArray();

    if (this.isCheckBox) {
        this.questionData.SelectedAnswers.forEach(
            function(answer) {
                this.selectedAnswerIds.push(answer.ProfileAnswerId);
            }.bind(this)
        );
    } else {
        this.selectedAnswerId(
            this.questionData.SelectedAnswers[0] ? this.questionData.SelectedAnswers[0].ProfileAnswerId : undefined
        );
    }

    this.answerResponse = ko.observableArray();

    this.shouldDisplay = ko.observable(false);

    this.showSelectedAnswer = function(id) {
        this.answerData.forEach(
            function(response) {
                if (response.AnswerId === id) {
                    var arr = this.answerResponse(),
                        count = 0;

                    // eslint-disable-next-line one-var
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].answer == response.AnswerText) {
                            count++;
                        }
                    }

                    if (count === 0) {
                        this.answerResponse.push({answer: response.AnswerText});
                    }
                }
            }.bind(this)
        );
    };

    this.changeAnswer = function() {
        this.showAnswer(false);
        this.showChoices(true);
    };

    this.getAnswer = function() {
        var selected = this.questionData.SelectedAnswers;

        selected.forEach(
            function(response) {
                if (response === null) {
                    this.changeAnswer();
                } else {
                    this.showAnswer(true);
                    this.showChoices(false);
                    this.showSelectedAnswer(response.ProfileAnswerId);
                }
            }.bind(this)
        );
    };

    this.displayAnswer = ko.computed(
        function() {
            this.getAnswer();
        }.bind(this)
    );

    this.getAnswerIds = function() {
        return !this.isCheckBox
            ? [+this.selectedAnswerId()]
            : this.selectedAnswerIds().map(function(id) {
                    return +id;
                });
    };

    this.save = function() {
        save(this).done(
            function() {
                this.answerResponse([]);
                this.getAnswer();
            }.bind(this)
        );
    };

    if (!this.isCheckBox) {
        this.selectedAnswerId.subscribe(
            function(id) {
                if (id !== -1 && id !== undefined) {
                    this.save();
                }
            }.bind(this)
        );
    }
}

export default Question;